import React, { Component } from 'react';

class Sample extends Component{
  render(){
    return (
      <div>
        <h2>SAMPLE PAGE</h2>
        <div>This is the very simple Sample</div>
      </div>
    );
  }
}

export default Sample;



// WEBPACK FOOTER //
// ./src/screens/Sample/Sample.js